import axios from 'axios'
import config from '../config'

const Class = {
    state: {
      classList: [],
      classDetail: {},
      error: false,
      msg: ''
    },
    mutations: {
        ClassList: (state, classList) => state.classList = classList,
        ClassDetail: (state, classDetail) => state.classDetail = classDetail,
        ERROR: (state, error) => state.error = error,
        MSG: (state, msg) => state.msg = msg
    },
    actions: {
       async fetchClassList({commit}, data){
           await axios({
               method:'post',
               url: config.LOAD_CLASS_LIST,
               data: data
           })
           .then((result) => {
               commit('ClassList', result.data.classes)
           }).catch((err) => {
               console.log(err);
                 });
        },
        async fetchClassDetail({commit}, data){
            await axios({
                method:'post',
                url: config.LOAD_CLASS_DETAIL,
                data: data
            })
            .then((result) => {
                commit('ClassDetail', result.data.class)
            }).catch((err) => {
                console.log(err);
            });
        },
        async addClass({commit}, data){
            await axios({
                method:'post',
                url: config.ADD_CLASS,
                data: data
            })
            .then((result) => {
                commit('ERROR', result.data.error)
                commit('MSG', result.data.msg)
            }).catch((err) => {
                console.log(err);
            });
        },
        async classUpdate({commit}, data){
            await axios({
                method:'post',
                url: config.CLASS_UPDATE,
                data: data
            })
            .then((result) => {
                commit('ERROR', result.data.error)
                commit('MSG', result.data.msg)
            }).catch((err) => {
                console.log(err);
            });
        },
        async classUpdateStatus({commit}, data){
            await axios({
                method:'post',
                url: config.CLASS_UPDATE_STATUS,
                data: data
            })
            .then((result) => {
                commit('ERROR', result.data.err)
                commit('MSG', result.data.msg)
            }).catch((err) => {
                console.log(err);
            });
        }
    },
    getters: {
        getClassList: state => state.classList,
        getClassDetail: state => state.classDetail,
        getClassError: state => state.error,
        getClassMsg: state => state.msg
    },
}

export default Class;